import { Middleware } from 'redux'
import { createLogger } from 'redux-logger'

const loggerMiddleware: Middleware = createLogger({ predicate: () => !process.env.NODE_ENV || process.env.NODE_ENV === 'development' })
export default loggerMiddleware